/* ═══════════════════════════════════════════════════════════════════════════════════════════════
   [D-558] «🧭 Провідник налаштування партнера» і «📌 Еталон функцій».
   OWNER 13.10: «треба додати або функцію або агента(самописного) щоб відслідковувало на якій стадії налаштування партнера і щоб
   підказував де і що треба натискати далі видяливши мігаючим цю дію. І щоб вів дод тих пір, поки не буде повністю налаштований
   новий партнер. Доречі - всі партнери повинні по дефолту мати такі самі функції для наданя їх своїм учням як наразі все
   виставлено для мого тестового акаунта Надія».

   Що зроблено, а що ні — каже сервер (GET /partners/{id}/setup: читає базу, сам нічого не міняє). Тут — лише показ:
   смужка кроків, текст «що натиснути» і БЛИМАННЯ тієї кнопки, яку треба натиснути зараз.
   Блимання: у кожного кроку є шлях із міток data-guide (вкладка → підвкладка → кнопка). Блимає НАЙГЛИБША мітка шляху, яка зараз
   є на екрані й не вимкнена: вкладку ще не відкрито — блимає вкладка; відкрито — підвкладка; далі сама кнопка. Тож провідник
   нічого не натискає за власника й не ламається, якщо той пішов іншою дорогою.
   Нова кнопка в шляху = мітка data-guide на ній + рядок у STEP_UI. Кроки й порядок — як у вкладці «🧭 Як створити партнера».
   ═══════════════════════════════════════════════════════════════════════════════════════════════ */
import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography, Button, Chip } from '@mui/material';
import api from '../api';

const C = { card: '#16202c', card2: '#1b2836', line: 'rgba(0,229,160,.22)', txt: '#eaf6ff', dim: '#a8bece',
            neon: '#00e5a0', neonTxt: '#7ffcd3', warn: '#ffb74d', gold: '#ffd166', blue: '#4fc3f7', coral: '#ff8a65' };
const G = (k) => '[data-guide="' + k + '"]';

/* шлях до дії (від загального до точного) · що сказати власнику · підпис кнопки «зроблено», якщо крок позначається руками */
const STEP_UI = {
  terms: { path: [G('tab-money'), G('fin-packages'), G('pay-details')],
           text: 'Відкрийте «💶 Фінанси» → «📦 Пакети» і впишіть у верхнє поле реквізити, на які платитимуть учні партнера. Збережеться, щойно клацнете поза полем. Частку прибутку можна змінити у «💶 Фінанси» → «🔁 Розрахунки» → «Ваша частка, %».' },
  packages: { path: [G('tab-money'), G('fin-packages'), G('pkg-add')],
              text: '«💶 Фінанси» → «📦 Пакети» → «➕ Створити пакет»: назва, ціна за місяць, скільки відео на день. Без пакета учневі нічого купити.' },
  feats: { path: [G('tab-feats'), G('tpl-apply')],
           text: 'Відкрийте «🧩 Функції». Угорі видно, чим цей партнер відрізняється від еталона, і кнопка «✅ Зробити як в еталона». Якщо відмінності задумані — натисніть тут «Так і лишити».',
           mark: '✔ Так і лишити' },
  access: { path: [G('tab-cab'), G('cab-access'), G('acc-in'), G('acc-add')],
            text: '«🌐 Кабінет» → «🔑 Доступ»: впишіть @нік або ID партнера й натисніть «➕ Додати акаунт». Партнеру прийде повідомлення з кнопкою входу.' },
  login: { path: [G('tab-cab'), G('cab-links'), G('copy-msg')],
           text: '«🌐 Кабінет» → «🔗 Посилання» → «📋 Скопіювати готове повідомлення партнеру» — надішліть його партнеру. Крок закриється сам, коли партнер уперше відкриє кабінет.',
           mark: '✔ Партнер уже заходив' },
  active: { path: [G('link-on'), G('link-btn')],
            text: 'Увімкніть «🔗 посилання для учнів» у рядку партнера. До цього бот за посиланням нікого не закріплює.' },
  preview: { path: [G('tab-cab'), G('cab-preview'), G('preview-nopay')],
             text: '«🌐 Кабінет» → «👀 Режим учня» → «🆕 новий, без оплати»: акаунт партнера побачить бота й Студію так, як їх бачитиме учень. Працює для акаунта, який уже заходив у кабінет.',
             mark: '✔ Перевірив' },
  drip: { path: [G('tab-lab'), G('lab-drip'), '[data-drip="start"]'],
          text: '«🧪 Дозволи і Теми» → «🗓 Графік» → «▶ Запустити графік цьому партнеру». Далі бот у потрібний день сам питатиме, чи відкривати наступні функції.',
          mark: '✔ Графік не потрібен' },
};

const CSS = `
@keyframes ptGuideBlink { 0%,100% { box-shadow: 0 0 0 0 rgba(255,209,102,.95), 0 0 0 0 rgba(255,209,102,.45); }
                          50% { box-shadow: 0 0 0 4px rgba(255,209,102,.95), 0 0 18px 8px rgba(255,209,102,.45); } }
.pt-guide-blink { animation: ptGuideBlink 1s ease-in-out infinite !important; outline: 2px solid #ffd166 !important; outline-offset: 2px;
                  border-radius: 8px; position: relative; z-index: 3; }
@keyframes ptGuideChip { 0%,100% { opacity: 1; } 50% { opacity: .55; } }
@media (prefers-reduced-motion: reduce) { .pt-guide-blink { animation: none !important; } }
`;

const usable = (el) => !!el && !el.disabled && el.getAttribute('aria-disabled') !== 'true' && el.offsetParent !== null;

/* найглибша мітка шляху, яка зараз є на екрані: спершу в картці цього партнера, потім деінде (вікно «Дозволи і Теми» — у порталі) */
export function guideTarget(pid, path) {
  const root = document.querySelector('[data-pt="' + pid + '"]');
  for (let i = path.length - 1; i >= 0; i--) {
    const a = root && root.querySelector(path[i]);
    if (usable(a)) return a;
    const b = document.querySelector('[data-guide-pid="' + pid + '"] ' + path[i]);
    if (usable(b)) return b;
  }
  return null;
}

/* Згорнутий рядок партнера: «🧭 3 з 8 · далі: Пакети» */
export function SetupChip({ s }) {
  if (!s || s.complete) return null;
  return (
    <Chip size="small" data-guide-chip="1" label={'🧭 налаштовано ' + s.done + ' з ' + s.total + ' · далі: ' + s.next_title}
      sx={{ bgcolor: 'rgba(255,209,102,.12)', color: C.gold, border: `1px solid ${C.gold}`, fontWeight: 700, animation: 'ptGuideChip 1.6s ease-in-out infinite' }} />
  );
}

export default function PartnerSetupGuide({ p, onRefresh }) {
  const pid = p.id;
  const [s, setS] = useState(p.setup || null);
  const [sel, setSel] = useState(null);       // крок, який власник відкрив сам (інакше — наступний незроблений)
  const [busy, setBusy] = useState(false);
  // [D-623] OWNER 17.10: «у дашборді коли відкриваю любого партнера вже дуже вашко зрозуміти що до чого» - кроки згорнуті в рядок,
  // розгорнуті лише для нового партнера (зроблено менше половини)
  const [open, setOpen] = useState(!!(p.setup && p.setup.done * 2 < p.setup.total));
  const last = useRef(null);
  const wasNext = useRef(p.setup ? p.setup.next : null);

  useEffect(() => { if (p.setup) setS(p.setup); }, [p.setup]);
  // стан освіжаємо самі: дії роблять різні вкладки, і не кожна повідомляє сторінку
  useEffect(() => {
    if (s && s.complete) return undefined;
    const tick = () => { if (!document.hidden) api.get(`/partners/${pid}/setup`).then(r => setS(r.data)).catch(() => {}); };
    const h = setInterval(tick, 4000);
    return () => clearInterval(h);
  }, [pid, s && s.complete]);
  // крок закрився → перейти до наступного й оновити рядок партнера
  useEffect(() => {
    const nx = s ? s.next : null;
    if (wasNext.current !== nx) { wasNext.current = nx; setSel(null); onRefresh && onRefresh(); }
  }, [s && s.next]);

  const cur = s ? (s.steps.find(x => x.k === sel) || s.steps.find(x => x.k === s.next) || null) : null;
  const blinkKey = open && cur && !cur.done ? cur.k : null;   // [D-623] блимає лише розгорнутий
  useEffect(() => {
    const clear = () => { if (last.current) { last.current.classList.remove('pt-guide-blink'); last.current = null; } };
    if (!blinkKey) { clear(); return undefined; }
    const tick = () => {
      const el = guideTarget(pid, STEP_UI[blinkKey].path);
      if (el !== last.current) { clear(); if (el) { el.classList.add('pt-guide-blink'); last.current = el; } }
    };
    tick();
    const h = setInterval(tick, 350);
    return () => { clearInterval(h); clear(); };
  }, [pid, blinkKey]);

  if (!s) return null;
  const show = () => { const el = cur && guideTarget(pid, STEP_UI[cur.k].path); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' }); };
  const mark = (done) => { setBusy(true); api.post(`/partners/${pid}/setup`, { step: cur.k, done }).then(r => setS(r.data)).catch(() => {}).finally(() => setBusy(false)); };

  if (s.complete && !sel) {
    return (
      <Box data-guide-box="done" sx={{ mt: 1.2, p: '8px 12px', borderRadius: 2, border: `1px solid ${C.line}`, bgcolor: 'rgba(0,229,160,.06)', display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
        <style>{CSS}</style>
        <Typography sx={{ color: C.neonTxt, fontWeight: 800, fontSize: 13 }}>✅ Партнера налаштовано повністю</Typography>
        <Typography sx={{ color: C.dim, fontSize: 12.5, flex: 1 }}>
          {s.life.students === 0 ? 'Далі — справа партнера: дати учням посилання або QR.' : `Учнів: ${s.life.students} · підтверджених оплат: ${s.life.paid}.`}
        </Typography>
        <Button size="small" data-guide-open="1" onClick={() => setSel(s.steps[0].k)} sx={{ textTransform: 'none', color: C.dim, fontSize: 12 }}>показати кроки</Button>
      </Box>
    );
  }
  if (!open && !sel) {   // [D-623] згорнутий: один рядок
    const nx = s.steps.find(x => x.k === s.next);
    return (
      <Box data-guide-box="mini" onClick={e => { e.stopPropagation(); setOpen(true); }}
           sx={{ mt: 1, p: '6px 10px', borderRadius: 2, border: `1px dashed ${C.gold}`, cursor: 'pointer', display: 'flex', gap: .8, alignItems: 'center', flexWrap: 'wrap' }}>
        <style>{CSS}</style>
        <Typography sx={{ color: C.gold, fontWeight: 800, fontSize: 12.5 }}>🧭 налаштовано {s.done} з {s.total}</Typography>
        <Typography sx={{ color: C.dim, fontSize: 12, flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{nx ? 'далі: ' + nx.t : ''}</Typography>
        <Typography sx={{ color: C.gold, fontSize: 12 }}>показати ▾</Typography>
      </Box>
    );
  }
  return (
    <Box data-guide-box="1" data-guide-next={s.next || ''} onClick={e => e.stopPropagation()}
         sx={{ mt: 1.2, p: 1.4, borderRadius: 2.5, border: `1px solid ${C.gold}`, bgcolor: 'rgba(255,209,102,.06)' }}>
      <style>{CSS}</style>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 1 }}>
        <Typography sx={{ color: C.gold, fontWeight: 800, fontSize: 13.5 }}>🧭 Провідник: налаштовано {s.done} з {s.total}</Typography>
        <Typography sx={{ color: C.dim, fontSize: 12, flex: 1 }}>жовтим блимає те, що натиснути зараз</Typography>
        <Button size="small" onClick={() => { setSel(null); setOpen(false); }} sx={{ textTransform: 'none', color: C.dim, fontSize: 12 }}>згорнути ▴</Button>
      </Box>
      <Box sx={{ display: 'grid', gap: .6, gridTemplateColumns: 'repeat(auto-fill, minmax(168px, 1fr))', mb: 1.2 }}>
        {s.steps.map((x, n) => {
          const on = cur && cur.k === x.k, nx = x.k === s.next;
          const col = x.done ? C.neon : nx ? C.gold : C.dim;
          return (
            <Button key={x.k} data-guide-step={x.k} data-guide-done={x.done ? 1 : 0} size="small" onClick={() => setSel(x.k)}
              sx={{ textTransform: 'none', justifyContent: 'flex-start', textAlign: 'left', fontSize: 12, lineHeight: 1.25, px: 1, py: .6, borderRadius: 1.5,
                    color: col, border: `1px solid ${on ? col : 'rgba(255,255,255,.1)'}`, bgcolor: on ? 'rgba(255,255,255,.06)' : 'transparent', fontWeight: on || nx ? 800 : 500 }}>
              <span style={{ marginRight: 6 }}>{x.done ? '✅' : nx ? '👉' : (n + 1) + '.'}</span>{x.t}
            </Button>
          );
        })}
      </Box>
      {cur && (
        <Box sx={{ bgcolor: C.card2, borderRadius: 2, p: 1.3, borderLeft: `3px solid ${cur.done ? C.neon : C.gold}` }}>
          <Typography data-guide-title="1" sx={{ color: C.txt, fontWeight: 800, fontSize: 14 }}>
            {cur.done ? '✅ ' : '👉 '}{cur.t}{cur.done ? (cur.marked && !cur.auto ? ' — позначено вами' : ' — зроблено') : ''}
          </Typography>
          <Typography data-guide-text="1" sx={{ color: C.txt, fontSize: 13, lineHeight: 1.5, mt: .5 }}>{STEP_UI[cur.k].text}</Typography>
          {cur.k === 'feats' && !cur.done && s.feats_diff > 0 &&
            <Typography sx={{ color: C.coral, fontSize: 12.5, mt: .4 }}>Відмінностей від еталона: {s.feats_diff}.</Typography>}
          <Box sx={{ display: 'flex', gap: .8, mt: 1, flexWrap: 'wrap' }}>
            {!cur.done && <Button size="small" data-guide-show="1" variant="contained" onClick={show}
              sx={{ textTransform: 'none', bgcolor: C.gold, color: '#1a1300', fontWeight: 800, fontSize: 12.5, '&:hover': { bgcolor: '#ffc94a' } }}>👉 Показати, де натиснути</Button>}
            {!cur.done && cur.can_mark && <Button size="small" data-guide-mark="1" disabled={busy} variant="outlined" onClick={() => mark(true)}
              sx={{ textTransform: 'none', borderColor: C.line, color: C.neonTxt, fontSize: 12.5 }}>{STEP_UI[cur.k].mark}</Button>}
            {cur.done && cur.marked && !cur.auto && <Button size="small" data-guide-unmark="1" disabled={busy} onClick={() => mark(false)}
              sx={{ textTransform: 'none', color: C.dim, fontSize: 12 }}>зняти позначку</Button>}
          </Box>
        </Box>
      )}
    </Box>
  );
}

/* ── «📌 Еталон функцій» — у вкладці «🧩 Функції» партнера ───────────────────────────────────────────────────────────── */
const ST = { open: 'показано', closed: 'сховано', silent: 'працює приховано', inherit: 'як усім' };

export function PartnerTemplatePanel({ p, onApplied, setToast, setErr }) {
  const pid = p.id;
  const [v, setV] = useState(null);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/partners/${pid}/template`).then(r => setV(r.data)).catch(() => {});
  useEffect(() => { load(); }, [pid]);
  if (!v) return null;
  const fail = (e) => setErr && setErr('Не вдалося' + ((e && e.response && e.response.data && e.response.data.detail) ? ': ' + e.response.data.detail : ''));
  const post = (action, okMsg) => { setBusy(true);
    api.post(`/partners/${pid}/template`, { action }).then(r => { setV(r.data); setOpen(false); setToast && setToast(okMsg); onApplied && onApplied(); }).catch(fail).finally(() => setBusy(false)); };
  const make = () => {
    if (!window.confirm(`Зробити «${p.name}» еталоном?\n\nКожен НОВИЙ партнер народжуватиметься з такими самими функціями, наборами й темами, як у цього. Уже створених партнерів це не змінить.`)) return;
    post('make', 'Еталон обрано');
  };
  const d = v.diff;
  const apply = () => {
    const parts = [d.feats.length && `функцій: ${d.feats.length}`, d.sets.length && `наборів: ${d.sets.length}`, d.themes.length && `тем: ${d.themes.length}`,
                   d.hidden.length && `карток у кабінеті партнера: ${d.hidden.length}`, d.cols.length && 'налаштування версій Студії'].filter(Boolean).join(', ');
    if (!window.confirm(`Зробити «${p.name}» таким самим, як еталон «${v.template.name}»?\n\nЗміниться — ${parts}.\nПакети, реквізити, відсотки, графік і те, що партнер сам закрив своїм учням, не зачіпаються.`)) return;
    post('apply', 'Функції виставлено як в еталона');
  };
  const box = { mb: 1.5, p: 1.3, borderRadius: 2.5, border: `1px solid ${C.line}`, bgcolor: 'rgba(255,255,255,.03)' };
  if (!v.template) {
    return (<Box data-tpl="none" sx={box}>
      <Typography sx={{ color: C.txt, fontSize: 13 }}>📌 Еталона для нових партнерів ще немає — нові отримують базовий набір.</Typography>
      <Button size="small" data-tpl-make="1" disabled={busy} onClick={make} sx={{ textTransform: 'none', color: C.neonTxt, mt: .5 }}>📌 Зробити цього партнера еталоном</Button>
    </Box>);
  }
  if (v.is_template) {
    return (<Box data-tpl="self" sx={{ ...box, borderColor: C.neon }}>
      <Typography sx={{ color: C.neonTxt, fontWeight: 800, fontSize: 13 }}>📌 Це еталон</Typography>
      <Typography sx={{ color: C.dim, fontSize: 12.5, mt: .3 }}>Кожен новий партнер народжується з такими самими функціями, наборами й темами, як тут зараз.
        Уже створених партнерів зміни тут не чіпають — їх вирівнює кнопка «Зробити як в еталона» у їхній вкладці «🧩 Функції».</Typography>
    </Box>);
  }
  const same = d.n === 0;
  return (
    <Box data-tpl="diff" data-tpl-n={d.n} sx={{ ...box, borderColor: same ? C.neon : C.gold }}>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
        <Typography sx={{ color: same ? C.neonTxt : C.gold, fontWeight: 800, fontSize: 13, flex: 1, minWidth: 220 }}>
          📌 Еталон — «{v.template.name}». {same ? 'Цей партнер налаштований так само.' : `Відмінностей: ${d.n}.`}
        </Typography>
        {!same && <Button size="small" data-tpl-toggle="1" onClick={() => setOpen(o => !o)} sx={{ textTransform: 'none', color: C.neonTxt, fontSize: 12.5 }}>{open ? 'сховати' : '👁 Що відрізняється'}</Button>}
        {!same && <Button size="small" data-guide="tpl-apply" disabled={busy} variant="contained" onClick={apply}
          sx={{ textTransform: 'none', bgcolor: C.neon, color: '#04121a', fontWeight: 800, fontSize: 12.5, '&:hover': { bgcolor: '#00c98c' } }}>✅ Зробити як в еталона</Button>}
        <Button size="small" data-tpl-make="1" disabled={busy} onClick={make} sx={{ textTransform: 'none', color: C.dim, fontSize: 12 }}>📌 зробити еталоном цього</Button>
      </Box>
      {open && !same && (
        <Box data-tpl-list="1" sx={{ display: 'grid', gap: .6, gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', mt: 1 }}>
          {d.feats.map(f => (
            <Box key={f.key} sx={{ p: '6px 9px', borderRadius: 1.5, bgcolor: C.card2, fontSize: 12.5, color: C.txt }}>
              {f.title}<br /><span style={{ color: C.dim }}>зараз: {ST[f.have]} → стане: </span><b style={{ color: f.want === 'closed' ? C.coral : C.neonTxt }}>{ST[f.want]}</b>
            </Box>
          ))}
          {d.sets.map(x => (<Box key={'s' + x.id} sx={{ p: '6px 9px', borderRadius: 1.5, bgcolor: C.card2, fontSize: 12.5, color: C.txt }}>
            📦 набір «{x.name}»<br /><b style={{ color: x.want ? C.neonTxt : C.coral }}>{x.want ? 'буде ввімкнено' : 'буде вимкнено'}</b></Box>))}
          {d.themes.map(x => (<Box key={'t' + x.id} sx={{ p: '6px 9px', borderRadius: 1.5, bgcolor: C.card2, fontSize: 12.5, color: C.txt }}>
            🎨 тема «{x.name}»<br /><b style={{ color: x.want ? C.neonTxt : C.coral }}>{x.want ? 'буде показано' : 'буде сховано'}</b></Box>))}
          {d.hidden.length > 0 && <Box sx={{ p: '6px 9px', borderRadius: 1.5, bgcolor: C.card2, fontSize: 12.5, color: C.txt }}>
            🙈 картки в кабінеті партнера: {d.hidden.length}<br /><span style={{ color: C.dim }}>сховані від партнера так само, як в еталона</span></Box>}
          {d.cols.length > 0 && <Box sx={{ p: '6px 9px', borderRadius: 1.5, bgcolor: C.card2, fontSize: 12.5, color: C.txt }}>
            🎬 Студія: увімкнення й кількість версій<br /><span style={{ color: C.dim }}>стане як в еталона</span></Box>}
        </Box>
      )}
    </Box>
  );
}
